import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { LoadingButton } from '@mui/lab';
import { ButtonGroup, Checkbox, Divider, Fab, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextareaAutosize, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import NoDataPlaceholder from 'app/shared/NoDataPlaceholder';
import StoneTableViewWIthAGRFormat from 'app/shared/StoneTableViewWIthAGRFormat';
import React, { useEffect, useRef, useState } from 'react';
import { useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import RemoveShoppingCartOutlinedIcon from '@mui/icons-material/RemoveShoppingCartOutlined';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import AutoAwesomeMotionOutlinedIcon from '@mui/icons-material/AutoAwesomeMotionOutlined';
import DataThresholdingOutlinedIcon from '@mui/icons-material/DataThresholdingOutlined';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import styled from '@emotion/styled';
import { Dialog, DialogTitle, DialogContent, TextField, Button, MenuItem } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import DiamondIcon from '@mui/icons-material/Diamond';
import * as XLSX from 'xlsx';
import ExcelGenerate, { BasketExcelGenerate, BasketExcelGenerateAdmin } from 'app/shared/ExcelGenerate/ExcelGenerateForSearch';
import Div from '@jumbo/shared/Div';
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import { DataGrid, GridCellEditStopReasons } from '@mui/x-data-grid';
import { calculateRapDis, calculateRateToDisc } from 'app/shared/csvToJson';
import { isMobileDevice } from 'app/utils/modifyArrayOfObjectsKeys';
{/* <TableCell align="right">
                <TextField size='small' disabled={row.STATUS != 'A'} type='number' id={`input-0-${index}`} min={0} max={100} sx={{ minWidth: 150 }} onBlur={(e) => handlediscChang(e, row, 0)} defaultValue={Number(row.MDISC || row.ASK_DISC).toFixed(2)} />
              </TableCell>
              <TableCell align="right">
                <TextField size='small' disabled={row.STATUS != 'A'}  type='number' id={`input-1-${index}`} min={0} sx={{ minWidth: 150 }} onBlur={(e) => handlediscChang(e, row, 1)} defaultValue={Number(row.mPrice || (row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC || row.ASK_DISC)) / 100)).toFixed(2)} />
              </TableCell>
              <TableCell align="right">
                <TextField size='small' disabled={row.STATUS != 'A'}  type='number' id={`input-2-${index}`} min={0} sx={{ minWidth: 150 }} onBlur={(e) => handlediscChang(e, row, 2)} defaultValue={Number(row.mamt || ((row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC || row.ASK_DISC)) / 100) * row.CARATS)).toFixed(2)} />
              </TableCell>
              <TableCell>
                  {jumboco?.curr?.cd +''+ (jumboco?.curr?.Rate *Number(row.mamt || ((row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC || row.ASK_DISC)) / 100) * row.CARATS))).toFixed(2)}
              </TableCell>
               <TableCell align="right">{((row.RAP_PRICE - (row.RAP_PRICE * row.ASK_DISC / 100)) * row.CARATS).toFixed(2)}/<sub>{row.ASK_DISC}</sub></TableCell>
              <TableCell align="right">{((row.RAP_PRICE - (row.RAP_PRICE * row.GREEN_DISC / 100)) * row.CARATS).toFixed(2)}/<sub>{row.GREEN_DISC}</sub></TableCell>
              <TableCell align="right">{((row.RAP_PRICE - (row.RAP_PRICE * row.RED_DISC / 100)) * row.CARATS).toFixed(2)}/<sub>{row.RED_DISC}</sub></TableCell> */}

export default function UserBasket() {
  const [basketData, setBasketData] = useState(null)
  const [inventoryType, setInventoryType] = useState('single')
  const [SelectedStone, setSelectedStone] = useState([])
  const [SelectedStoneBasketData, setSelectedStoneBasketData] = useState([])
  const isMobile= isMobileDevice()
  const [opetMemoDialoge, setOpetMemoDialoge] = useState(false)
  const [opetSoldDialoge, setOpetSoldDialoge] = useState(false)
  // const [userParty, setUserParty] = useState(null)
  const [userSelectedParty, setUserSelectedParty] = useState('')
  const swal = useSwalWrapper();
  const gridRef = useRef(null);
  const jumboco = useJumboAuth();
  const [BLOADER, setBLOADER] = useState(false)
  const getFieldValue = async (params) => {
    let tmpmdisfield;
    let tmpmdisOBj;
    setTimeout(async () => {
      let cellval = await gridRef.current.getCellValue(params.id, params.field);
      // console.log(cellval);
      if (Boolean(cellval) && Number(cellval)) {
      switch (params.field) {
        case 'MDISC':
          tmpmdisfield = cellval;
          let price = calculateRapDis(params.row.RAP_PRICE, cellval)
          tmpmdisOBj = { ...params.row,
                        MDISC: (cellval)?.toFixed(2),
                        MDISCP: (price)?.toFixed(2),
                        MDISCS: (price * params.row.CARATS)?.toFixed(2),
                        MDISC2: ((price * params.row.CARATS) * jumboco?.curr?.Rate)?.toFixed(2)
                      }
          break;
        case 'MDISCP':
          // let discvals =await gridRef.current.getCellValue(params.id, 'MDISC');
          tmpmdisfield = calculateRateToDisc(params.row.RAP_PRICE, cellval);
          tmpmdisOBj = { ...params.row,
             MDISC: tmpmdisfield?.toFixed(2),
             MDISCP: cellval?.toFixed(2),
             MDISCS: (cellval * params.row.CARATS)?.toFixed(2),
             MDISC2: ((cellval * params.row.CARATS) * jumboco?.curr?.Rate)?.toFixed(2) 
             }
          // let discval =await gridRef.current.getCellValue(params.id, 'MDISC');
          // tmpmdisfield = calculateRapDis(params.row.RAP_PRICE,discval);
          break;
        case 'MDISCS':
          let discvals = cellval / params.row.CARATS;
          tmpmdisfield = calculateRateToDisc(params.row.RAP_PRICE, discvals);
          tmpmdisOBj = { ...params.row,
              MDISC: tmpmdisfield?.toFixed(2),
              MDISCP: discvals?.toFixed(2),
              MDISCS: cellval?.toFixed(2),
              MDISC2: ((cellval) * jumboco?.curr?.Rate)?.toFixed(2) }
          break;
        case 'MDISC2':
          let discvalsamt = (cellval / jumboco?.curr?.Rate);
          let discvals2 = (cellval / jumboco?.curr?.Rate) / params.row.CARATS;
          tmpmdisfield = calculateRateToDisc(params.row.RAP_PRICE, discvals2);
          tmpmdisOBj = { ...params.row,
               MDISC: tmpmdisfield?.toFixed(2),
              MDISCP: discvals2?.toFixed(2),
              MDISCS: discvalsamt?.toFixed(2), 
              MDISC2: cellval?.toFixed(2) 
              }
          break;
        default:
          tmpmdisfield = 0;
          break;
      }
      let upObj = basketData.map(sdata => { if (sdata.STONE == params.id) { return tmpmdisOBj } else { return sdata } })
      setBasketData(upObj);
    }

    }, 100);
    // const selectedIndex = basketData.findIndex(item => item.STONE === rowId);
    // let tmpmdisfield;
    // let cellval =await gridRef.current.getCellValue(rowId, field);
    // alert(cellval)
    // console.log(cellval);
    // switch (field) {
    //   case 'MDISC':
    //     tmpmdisfield = gridRef.current.getCellValue(rowId, field);
    //     break;
    //   case 'MDISCP':
    //     let tmpval = gridRef.current.getCellValue(rowId, 'MDISC');
    //     tmpmdisfield = (100 - (Number(tmpval) * 100) / Number(gridRef.current.getCellValue(rowId, 'RAP_PRICE')));
    //     break;
    //   default:
    //     tmpmdisfield = 0;
    //     break;
    // }
    // console.log(gridRef.current.getCellValue(rowId, 'RAP_PRICE'));
    // console.log(gridRef.current.getRow(rowId));

    // if (selectedIndex !== -1) {
    //   const updatedObj = {
    //     ...basketData[selectedIndex], // Copy the existing object
    //     MDISC: tmpmdisfield?.toFixed(2)  // Update the MDISC property
    //   };
    //   // basketData.map()
    //   const updatedBasketData = [...basketData]; // Create a copy of the original array
    //   updatedBasketData[selectedIndex] = updatedObj; // Replace the object at selectedIndex

    //   setBasketData(updatedBasketData); // Update state with the modified array
    // }
  };


  useEffect(() => {
    let data = basketData?.filter(d => SelectedStone?.includes(d.STONE))
    setSelectedStoneBasketData(data || [])
  }, [SelectedStone]);
  const fetchBasketdata = useCallback(() =>{
    setBasketData(null)
    setSelectedStone([])
    {
     jwtAuthAxios.post(`user/userbasket`,{type:"S",stype:inventoryType}).then((res) => {
        // console.log(res.data.data);
        // res.data.data.sort((a, b) => (a.STONE > b.STONE ? 1 : -1));
        setBasketData(res.data.data)
      }).catch(e => {
        swal.fire({
          icon: 'error',
          text: 'Internal server Error',
        });
      })
    }
  },[inventoryType])
  useEffect(() => {
    // alert(inventoryType)
    fetchBasketdata();
  }, [inventoryType]);
  // useEffect(() => {
  //   jwtAuthAxios.get(`master/helper?party=1`).then((res) => {
  //     setUserParty(res.data?.data?.PARTY || [])
  //   }).catch(e => {
  //     swal.fire({
  //       icon: 'error',
  //       text: 'Internal server Error',
  //     });
  //   })
  //   // fetchBasketdata();
  // }, []);

  // useEffect(() => {
  //   fetchBasketdata();
  // }, [userSelectedParty]);
  const RemovetoBasketHandler = () => {
    setBLOADER(true)
    jwtAuthAxios.post(`user/userbasket`, {type:"D",stype:inventoryType, "stone_id": SelectedStone}).then((res) => {
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
      fetchBasketdata()
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      })
    }).finally(() => setBLOADER(false));
  }
  // const ShippingFormMemoDialog = ({ SelectedStone, userSelectedParty, basketData, open, handleClose }) => {
  //   const [helperdata, setHelperdata] = useState([])
  //   const [ButtonLoadng, setButtonLoadng] = useState(false)
  //   const swal = useSwalWrapper()
  //   const handleSubmit = async (values, { resetForm }) => {
  //     // Handle form submission logic here
  //     let SelectedData = basketData?.filter((sdata => SelectedStone.includes(sdata.STONE)))
  //     // resetForm();
  //     if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
  //       setButtonLoadng(true)
  //       await jwtAuthAxios.post(`transation/${inventoryType == 'single' ? 'polishOutward' : 'bulk/polishOutward'}`, { ...values, Party: userSelectedParty, transactionType: helperdata.PVID, StoneData: SelectedData, isDetail: 'Y' }).then((res) => {
  //         swal.fire({
  //           icon: 'success',
  //           text: res.data.message,
  //         });
  //         resetForm();
  //         handleClose();
  //       }).catch(e => {
  //         swal.fire({
  //           icon: 'error',
  //           text: 'Internal server Error',
  //         });
  //       }).finally(() => {
  //         setButtonLoadng(false)
  //       })
  //     }
  //     else {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Please Fill Detail',
  //       });
  //     }
  //   };
  //   const jumboco = useJumboAuth();
  //   const initialValues = {
  //     shippingNumber: '',
  //     FL_CURR_CODE: '2',
  //     FL_CONV_RATE: jumboco?.curr?.Rate,
  //     term: '',
  //     shipBy: '37',
  //     narration: ''
  //   };
  //   useEffect(() => {
  //     jwtAuthAxios.get(`master/helper?paramsData=SHIPPEDBY&term=1&PVID=Memo&curr=1`).then((res) => {
  //       setHelperdata(res.data?.data)
  //     }).catch(e => {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Internal server Error',
  //       });
  //     })
  //     // fetchBasketdata();
  //   }, []);

  //   return (
  //     <Dialog open={open} maxWidth={'lg'} onClose={handleClose}>
  //       <DialogTitle>Shipping Information</DialogTitle>
  //       <DialogContent>
  //         <Formik initialValues={initialValues} onSubmit={handleSubmit}>
  //           {({ handleSubmit, setFieldValue }) => (
  //             <Form onSubmit={handleSubmit}>
  //               <Grid container spacing={2}>
  //                 <Grid item lg={6}>
  //                   <Field name="FL_CURR_CODE" size="small" a as={TextField} style={{ margin: '7px 0' }} select label="Currency Type" fullWidth>
  //                     {helperdata?.CURR?.map((option) => (
  //                       <MenuItem key={option.FL_CURRENCY_ID} value={option.FL_CURRENCY_ID}>
  //                         {option.FL_CURRENCY_NAME}
  //                       </MenuItem>
  //                     ))}
  //                   </Field>
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                   <Field name="FL_CONV_RATE" size="small" as={TextField} style={{ margin: '7px 0' }} type="number" label="Conv Rate" fullWidth />
  //                 </Grid>
  //               </Grid>
  //               <Field name="term" size="small" as={TextField} style={{ margin: '7px 0' }} select label="Memo Term" fullWidth>
  //                 {helperdata?.TERM?.map((option) => (
  //                   <MenuItem key={option.FL_TERM_CODE} color='primary' value={option.FL_TERM_CODE}>
  //                     {option.FL_TERM_NAME}
  //                   </MenuItem>
  //                 ))}
  //               </Field>
  //               <Field name="shippingNumber" size="small" as={TextField} style={{ margin: '7px 0' }} label="Tracking Number" fullWidth />
  //               <Field name="shipBy" size="small" as={TextField} style={{ margin: '7px 0' }} select label="Ship By" fullWidth>
  //                 {helperdata?.SHIPPEDBY?.map((option) => (
  //                   <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
  //                     {option.FL_PARA_VALUE}
  //                   </MenuItem>
  //                 ))}
  //               </Field>
  //               <InputLabel>Naration</InputLabel>
  //               <Field size="small"
  //                 component={TextareaAutosize}
  //                 name="narration"
  //                 label="Naration"
  //                 minRows={3}
  //                 onChange={(e) => setFieldValue('narration', e.target.value)}
  //                 style={{ width: '100%' }}
  //                 fullWidth
  //               />
  //               <LoadingButton loading={ButtonLoadng} variant="contained" color='primary' sx={{
  //                 display: 'block',
  //                 marginLeft: 'auto', mt: 3
  //               }} type="submit">Memo</LoadingButton>
  //             </Form>
  //           )}
  //         </Formik>
  //       </DialogContent>
  //     </Dialog>
  //   );
  // };
  // const ShippingFormSoldDialog = ({ SelectedStone, userSelectedParty, open, handleClose }) => {
  //   const [helperdata, setHelperdata] = useState([])
  //   const [ButtonLoadng, setButtonLoadng] = useState(false)
  //   const [stoneDataDetailData, setStoneDataDetailData] = useState([])
  //   const [stoneDataDetail, setStoneDataDetail] = useState(null)
  //   const [CurrencyName, setCurrencyName] = useState(null)
  //   const swal = useSwalWrapper()
  //   const Item = styled(Paper)(({ theme }) => ({
  //     backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  //     ...theme.typography.body2,
  //     padding: theme.spacing(1),
  //     textAlign: 'center',
  //     color: theme.palette.text.secondary,
  //   }));
  //   useEffect(() => {
  //     let sdataD = basketData?.filter((sdata => SelectedStone.includes(sdata.STONE)))
  //     console.log(sdataD);
  //     setStoneDataDetailData(sdataD)
  //   }, [SelectedStone])
  //   useEffect(() => {
  //     console.log(basketData);
  //   }, [basketData])
  //   useEffect(() => {
  //     let TMPOBJ = {
  //       pcs: stoneDataDetailData.length,
  //       cts: stoneDataDetailData.reduce((acc, obj) => acc + obj.CARATS, 0),
  //       disc: ((stoneDataDetailData.reduce((acc, obj) => acc + obj.MDISC, 0)) / stoneDataDetailData.length),
  //       rap: (stoneDataDetailData.reduce((acc, obj) => acc + obj.RAP_PRICE, 0) / stoneDataDetailData.length)
  //     }
  //     setStoneDataDetail({ ...TMPOBJ, price: (TMPOBJ?.rap - ((TMPOBJ?.rap * TMPOBJ?.disc) / 100)) })
  //   }, [basketData, stoneDataDetailData])
  //   const handleSubmit = async (values, { resetForm }) => {
  //     // Handle form submission logic here
  //     if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
  //       // let SelectedData = basketData.filter((sdata => SelectedStone.includes(sdata.STONE)))
  //       setButtonLoadng(true)
  //       // resetForm();
  //       await jwtAuthAxios.post(`transation/polishOutward`, { ...values, Party: userSelectedParty, transactionType: helperdata.PVID, StoneData: stoneDataDetailData, isDetail: 'Y' }).then((res) => {
  //         swal.fire({
  //           icon: 'success',
  //           text: res.data.message,
  //         });
  //         resetForm();
  //         handleClose();
  //       }).catch(e => {
  //         swal.fire({
  //           icon: 'error',
  //           text: 'Internal server Error',
  //         });
  //       }).finally(() => {
  //         setButtonLoadng(false)
  //       })
  //     } else {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Please Fill Detail',
  //       });
  //     }
  //   };
  //   const jumboco = useJumboAuth();
  //   const initialValues = {
  //     shippingNumber: '',
  //     term: '',
  //     shipBy: '',
  //     ShipingCharge: 0,
  //     CertCharge: 0,
  //     narration: '',
  //     OtherCharge: 0,
  //     Discount: 0,
  //     wat_per: 0,
  //     FL_CURR_CODE: '2',
  //     FL_CONV_RATE: jumboco?.curr?.Rate,
  //   };
  //   useEffect(() => {
  //     jwtAuthAxios.get(`master/helper?paramsData=SHIPPEDBY&term=1&PVID=Sold&curr=1`).then((res) => {
  //       setHelperdata(res.data?.data)
  //     }).catch(e => {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Internal server Error',
  //       });
  //     })
  //     // fetchBasketdata();
  //   }, []);

  //   return (
  //     <Dialog open={open} onClose={handleClose}>
  //       <DialogTitle>Sold Shipping Information</DialogTitle>
  //       <DialogContent >
  //         <Formik initialValues={initialValues} onSubmit={handleSubmit}>
  //           {({ handleSubmit, values, setFieldValue }) => (
  //             <Form onSubmit={handleSubmit}>
  //               <Grid container spacing={2}>
  //                 <Grid item lg={6}>
  //                   <Field name="FL_CURR_CODE" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Currency Type" fullWidth>
  //                     {helperdata?.CURR?.map((option) => (
  //                       <MenuItem key={option.FL_CURRENCY_ID} onClick={(e) => { setCurrencyName(option.FL_CURRENCY_NAME) }} value={option.FL_CURRENCY_ID}>
  //                         {option.FL_CURRENCY_NAME}
  //                       </MenuItem>
  //                     ))}
  //                   </Field>
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                   <Field name="FL_CONV_RATE" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} type="number" label="Conv Rate" fullWidth />
  //                 </Grid>
  //               </Grid>

  //               <Field name="term" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Payment Term" fullWidth>
  //                 {helperdata?.TERM?.map((option) => (
  //                   <MenuItem key={option.FL_TERM_CODE} color='primary' value={option.FL_TERM_CODE}>
  //                     {option.FL_TERM_NAME}
  //                   </MenuItem>
  //                 ))}
  //               </Field>
  //               <Field name="shippingNumber" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Shipping Number" fullWidth />
  //               <Field name="shipBy" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Ship By" fullWidth>
  //                 {helperdata?.SHIPPEDBY?.map((option) => (
  //                   <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
  //                     {option.FL_PARA_VALUE}
  //                   </MenuItem>
  //                 ))}
  //               </Field>
  //               <Grid container columnSpacing={2}>
  //                 <Grid item lg={6}>
  //                   <Field name="wat_per" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="vat Charge(%)" fullWidth />
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                   <Field name="ShipingCharge" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Shiping Charge(AMT)" fullWidth />
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                   <Field name="CertCharge" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Cert. Charge(AMT)" fullWidth />
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                   <Field name="OtherCharge" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="OtherCharge(AMT)" fullWidth />
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                 </Grid>
  //               </Grid>
  //               <Field name="Discount" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Discount(-AMT)" fullWidth />
  //               <InputLabel>Naration</InputLabel>
  //               <Field size="small"
  //                 component={TextareaAutosize}
  //                 name="narration"
  //                 label="Naration"
  //                 minRows={3}
  //                 onChange={(e) => setFieldValue('narration', e.target.value)}
  //                 style={{ width: '100%' }}
  //                 fullWidth
  //               />
  //               <Field
  //                 name="is_p"
  //                 render={({ field }) => (
  //                   <FormControlLabel
  //                     control={
  //                       <Checkbox
  //                         {...field}
  //                         style={{ margin: '5px 0' }}
  //                         size="small"
  //                       // checked={field.value}
  //                       // Add any other Checkbox props here
  //                       />
  //                     }
  //                     label="IS P"
  //                     fullWidth
  //                   />
  //                 )}
  //               />
  //               <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1, mt: 3 }} >
  //                 <Item>Pcs  {stoneDataDetail?.pcs || 0}</Item>
  //                 <Item>CTS  {stoneDataDetail?.cts?.toFixed(2) || 0.00}</Item>
  //                 <Item>Rap  {stoneDataDetail?.rap.toFixed(2) || 0}</Item>
  //                 <Item>Disc%  {stoneDataDetail?.disc?.toFixed(2) || 0}</Item>
  //                 <Item>vat%  {values.wat_per || 0}</Item>
  //               </Stack>
  //               <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1 }} >
  //                 <Item>ShipingCharge ($AMT) = {values.ShipingCharge || 0}</Item>
  //                 <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
  //                 <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
  //                 <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
  //               </Stack>
  //               <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1 }} >
  //                 <Item>Price/cts($) = {(stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per || 0)) / 100))?.toFixed(2) || 0}</Item>
  //                 {/* <Item>Total Amt ($) = {((stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per||0))/100) + values.CertCharge + values.OtherCharge +values.ShipingCharge -values.Discount) * stoneDataDetail?.cts)?.toFixed(2) || 0}</Item>
  //                   <Item>Total Amt ({CurrencyName || 'RMB'}) = {(((stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per||0))/100) + values.CertCharge + values.OtherCharge +values.ShipingCharge - values.Discount) * values.FL_CONV_RATE) * stoneDataDetail?.cts)?.toFixed(2) || 0}</Item> */}
  //                 <Item>Total Amt ($) = {((
  //                   ((Number(stoneDataDetail?.price || 0) * Number(stoneDataDetail?.cts || 0)) +
  //                     (((stoneDataDetail?.price || 0) * (values.wat_per || 0)) / 100) +
  //                     (values.CertCharge || 0) +
  //                     (values.OtherCharge || 0) +
  //                     (values.ShipingCharge || 0))
  //                 ) - (values.Discount || 0)).toFixed(2)}</Item>
  //                 <Item>Total Amt ({CurrencyName || 'RMB'}) = {(((
  //                   ((Number(stoneDataDetail?.price || 0) * Number(stoneDataDetail?.cts || 0)) +
  //                     (((stoneDataDetail?.price || 0) * (values.wat_per || 0)) / 100) +
  //                     (values.CertCharge || 0) +
  //                     (values.OtherCharge || 0) +
  //                     (values.ShipingCharge || 0))
  //                 ) - (values.Discount || 0)) * values.FL_CONV_RATE).toFixed(2)}</Item>
  //               </Stack>
  //               <LoadingButton loading={ButtonLoadng} variant="contained" color='primary' sx={{ display: 'block', marginLeft: 'auto', mt: 3 }} type="submit">Sold</LoadingButton>
  //             </Form>
  //           )}
  //         </Formik>
  //       </DialogContent>
  //     </Dialog>
  //   );
  // };
  // const BulkShippingFormSoldDialog = ({ SelectedStone, userSelectedParty, open, handleClose }) => {
  //   const [helperdata, setHelperdata] = useState([])
  //   const [ButtonLoadng, setButtonLoadng] = useState(false)
  //   const [stoneDataDetailData, setStoneDataDetailData] = useState([])
  //   const [stoneDataDetail, setStoneDataDetail] = useState(null)
  //   const [CurrencyName, setCurrencyName] = useState(null)
  //   const swal = useSwalWrapper()
  //   const Item = styled(Paper)(({ theme }) => ({
  //     backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  //     ...theme.typography.body2,
  //     padding: theme.spacing(1),
  //     textAlign: 'center',
  //     color: theme.palette.text.secondary,
  //   }));
  //   useEffect(() => {
  //     let sdataD = basketData?.filter((sdata => SelectedStone.includes(sdata.STONE)))
  //     console.log(sdataD);
  //     setStoneDataDetailData(sdataD)
  //   }, [SelectedStone])
  //   useEffect(() => {
  //     console.log(basketData);
  //   }, [basketData])
  //   useEffect(() => {
  //     let TMPOBJ = {
  //       pcs: stoneDataDetailData.length,
  //       cts: stoneDataDetailData.reduce((acc, obj) => acc + obj.FL_SELL_CARATS, 0),
  //       price: ((stoneDataDetailData.reduce((acc, obj) => acc + obj.FL_RATE, 0)) / stoneDataDetailData.length)
  //     }
  //     setStoneDataDetail({ ...TMPOBJ, amt: TMPOBJ.price * TMPOBJ.cts })
  //   }, [basketData, stoneDataDetailData])
  //   const handleSubmit = async (values, { resetForm }) => {
  //     // Handle form submission logic here
  //     if (values.term && values.FL_CURR_CODE && values.FL_CURR_CODE) {
  //       // let SelectedData = basketData.filter((sdata => SelectedStone.includes(sdata.STONE)))
  //       setButtonLoadng(true)
  //       // resetForm();
  //       await jwtAuthAxios.post(`transation/bulk/polishOutward`, { ...values, Party: userSelectedParty, transactionType: helperdata.PVID, StoneData: stoneDataDetailData, isDetail: 'Y' }).then((res) => {
  //         swal.fire({
  //           icon: 'success',
  //           text: res.data.message,
  //         });
  //         resetForm();
  //         handleClose();
  //       }).catch(e => {
  //         swal.fire({
  //           icon: 'error',
  //           text: 'Internal server Error',
  //         });
  //       }).finally(() => {
  //         setButtonLoadng(false)
  //       })
  //     } else {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Please Fill Detail',
  //       });
  //     }
  //   };
  //   const jumboco = useJumboAuth();
  //   const initialValues = {
  //     shippingNumber: '',
  //     term: '',
  //     shipBy: '',
  //     ShipingCharge: 0,
  //     CertCharge: 0,
  //     OtherCharge: 0,
  //     Discount: 0,
  //     wat_per: 0,
  //     narration: '',
  //     FL_CURR_CODE: '2',
  //     FL_CONV_RATE: jumboco?.curr?.Rate,
  //   };
  //   useEffect(() => {
  //     jwtAuthAxios.get(`master/helper?paramsData=SHIPPEDBY&term=1&PVID=Sold&curr=1`).then((res) => {
  //       setHelperdata(res.data?.data)
  //     }).catch(e => {
  //       swal.fire({
  //         icon: 'error',
  //         text: 'Internal server Error',
  //       });
  //     })
  //     // fetchBasketdata();
  //   }, []);

  //   return (
  //     <Dialog open={open} onClose={handleClose}>
  //       <DialogTitle>Sold Shipping Information</DialogTitle>
  //       <DialogContent >
  //         <Formik initialValues={initialValues} onSubmit={handleSubmit}>
  //           {({ handleSubmit, values, setFieldValue }) => (
  //             <Form onSubmit={handleSubmit}>
  //               <Grid container spacing={2}>
  //                 <Grid item lg={6}>
  //                   <Field name="FL_CURR_CODE" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Currency Type" fullWidth>
  //                     {helperdata?.CURR?.map((option) => (
  //                       <MenuItem key={option.FL_CURRENCY_ID} onClick={(e) => { setCurrencyName(option.FL_CURRENCY_NAME) }} value={option.FL_CURRENCY_ID}>
  //                         {option.FL_CURRENCY_NAME}
  //                       </MenuItem>
  //                     ))}
  //                   </Field>
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                   <Field name="FL_CONV_RATE" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} type="number" label="Conv Rate" fullWidth />
  //                 </Grid>
  //               </Grid>

  //               <Field name="term" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Payment Term" fullWidth>
  //                 {helperdata?.TERM?.map((option) => (
  //                   <MenuItem key={option.FL_TERM_CODE} color='primary' value={option.FL_TERM_CODE}>
  //                     {option.FL_TERM_NAME}
  //                   </MenuItem>
  //                 ))}
  //               </Field>
  //               <Field name="shippingNumber" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Shipping Number" fullWidth />
  //               <Field name="shipBy" as={TextField} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} select label="Ship By" fullWidth>
  //                 {helperdata?.SHIPPEDBY?.map((option) => (
  //                   <MenuItem key={option.FL_PARA_VALUE} value={option.FL_GPID}>
  //                     {option.FL_PARA_VALUE}
  //                   </MenuItem>
  //                 ))}
  //               </Field>
  //               <Grid container columnSpacing={2}>
  //                 <Grid item lg={6}>
  //                   <Field name="wat_per" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="vat Charge(%)" fullWidth />
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                   <Field name="ShipingCharge" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Shiping Charge(AMT)" fullWidth />
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                   <Field name="CertCharge" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Cert. Charge(AMT)" fullWidth />
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                   <Field name="OtherCharge" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="OtherCharge(AMT)" fullWidth />
  //                 </Grid>
  //                 <Grid item lg={6}>
  //                 </Grid>
  //               </Grid>
  //               <Field name="Discount" as={TextField} type="number" min={'0'} defaultValue={'0'} style={{ margin: '5px 0' }} InputProps={{ size: 'small' }} InputLabelProps={{ size: 'small' }} label="Discount(-AMT)" fullWidth />
  //               <InputLabel>Naration</InputLabel>
  //               <Field size="small"
  //                 component={TextareaAutosize}
  //                 name="narration"
  //                 label="Naration"
  //                 minRows={3}
  //                 onChange={(e) => setFieldValue('narration', e.target.value)}
  //                 style={{ width: '100%' }}
  //                 fullWidth
  //               />
  //               <Field
  //                 name="is_p"
  //                 render={({ field }) => (
  //                   <FormControlLabel
  //                     control={
  //                       <Checkbox
  //                         {...field}
  //                         style={{ margin: '5px 0' }}
  //                         size="small"
  //                       // checked={field.value}
  //                       // Add any other Checkbox props here
  //                       />
  //                     }
  //                     label="IS P"
  //                     fullWidth
  //                   />
  //                 )}
  //               />
  //               <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1, mt: 3 }} >
  //                 <Item>Lot:  {stoneDataDetail?.pcs || 0}</Item>
  //                 <Item>CTS  {stoneDataDetail?.cts?.toFixed(2) || 0.00}</Item>
  //                 {/* <Item>Price  {stoneDataDetail?.price.toFixed(2) || 0}</Item>
  //                 <Item>Amount  {stoneDataDetail?.amt?.toFixed(2) || 0}</Item> */}
  //                 <Item>vat%  {values.wat_per || 0}</Item>
  //               </Stack>
  //               <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1 }} >
  //                 <Item>ShipingCharge ($AMT) = {values.ShipingCharge || 0}</Item>
  //                 <Item>OtherCharge ($AMT) = {values.OtherCharge || 0}</Item>
  //                 <Item>CertCharge ($AMT) = {values.CertCharge || 0}</Item>
  //                 <Item>Disc($AMT) = (-{values.Discount || 0})</Item>
  //               </Stack>
  //               <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2} sx={{ mb: 1 }} >
  //                 <Item>Price/cts($) = {(stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per || 0)) / 100))?.toFixed(2) || 0}</Item>
  //                 {/* <Item>Total Amt ($) = {((stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per||0))/100) + values.CertCharge + values.OtherCharge +values.ShipingCharge -values.Discount) * stoneDataDetail?.cts)?.toFixed(2) || 0}</Item>
  //                   <Item>Total Amt ({CurrencyName || 'RMB'}) = {(((stoneDataDetail?.price + ((stoneDataDetail?.price * (values.wat_per||0))/100) + values.CertCharge + values.OtherCharge +values.ShipingCharge - values.Discount) * values.FL_CONV_RATE) * stoneDataDetail?.cts)?.toFixed(2) || 0}</Item> */}
  //                 <Item>Total Amt ($) = {((
  //                   (Number(stoneDataDetail?.amt || 0) +
  //                     (((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) / 100) +
  //                     (values.CertCharge || 0) +
  //                     (values.OtherCharge || 0) +
  //                     (values.ShipingCharge || 0))
  //                 ) - (values.Discount || 0)).toFixed(2)}</Item>
  //                 <Item>Total Amt ({CurrencyName || 'RMB'}) = {(((
  //                   (Number(stoneDataDetail?.amt || 0) +
  //                     (((stoneDataDetail?.amt || 0) * (values.wat_per || 0)) / 100) +
  //                     (values.CertCharge || 0) +
  //                     (values.OtherCharge || 0) +
  //                     (values.ShipingCharge || 0))
  //                 ) - (values.Discount || 0)) * values.FL_CONV_RATE).toFixed(2)}</Item>
  //               </Stack>
  //               <LoadingButton loading={ButtonLoadng} variant="contained" color='primary' sx={{ display: 'block', marginLeft: 'auto', mt: 3 }} type="submit">Sold</LoadingButton>
  //             </Form>
  //           )}
  //         </Formik>
  //       </DialogContent>
  //     </Dialog>
  //   );
  // };
  const StoneTableViewWIthBasket = ({ SelectedStoneBasketData, setSelectedStoneBasketData, Stoneresultdata, SelectedStone, setSelectedStone, setStoneresultdata, isedit = false }) => {
    const [selectedStoneDetails, setSelectedStoneDetails] = useState({ pcs: 0, cts: 0, rap: 0, disc: 0 })
    const [discVal, setDiscVal] = useState({ discType: 'ASK_DISC', Disc: 0 })
    const jumboco = useJumboAuth();
    // console.log(jumboco?.curr);
    const useStyles = makeStyles((theme) => ({
      RedCell: {
        background: theme.palette.error.main,
        color: '#fff'
      },
      GreenCell: {
        background: 'green',
        color: '#fff'
      },
      ASkCell: {
        background: theme.palette.info.main,
        color: '#fff'
      },
    }));
    const classes = useStyles();
    const columns = [
      // { field: 'PARTY', flex: 1, headerName: 'Party', headerClassName: 'TopHeader', renderCell: (params) => (params.value == ' ()' ? '-' : params.value) },
      { field: 'STATUS',width:15,headerName: 'S' ,},
      { field: 'STONE', flex: 1, headerName: 'StoneId' },
      { field: 'LAB', width:15, headerName: 'Lab' },
      { field: 'REPORTNO', flex: 1, headerName: 'ReportNO' },
      { field: 'SHAPE', flex: 1, headerName: 'Shape' },
      { field: 'CARATS', flex: 1, headerName: 'Carats' },
      { field: 'COLOR', flex: 1, headerName: 'Color' },
      { field: 'CLARITY', flex: 1, headerName: 'Clarity' },
      { field: 'RAP_PRICE', flex: 1, headerName: 'Rap($)' },
      { field: 'MDISC', type: 'number', flex: 1, headerName: 'Discount(%)',  renderCell: ({ row, value }) => Number(value) && Number(value)?.toFixed(2) },
      { field: 'MDISCP', type: 'number', flex: 1, headerName: 'Price($)',  renderCell: ({ row, value }) => value || (Number((row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC)) / 100))?.toFixed(2)) },
      { field: 'MDISCS', type: 'number', flex: 1, headerName: 'Amount($)',  renderCell: ({ row, value }) => value || Number(((row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC)) / 100) * row.CARATS))?.toFixed(2) },
      { field: 'MDISC2', type: 'number', flex: 1, headerName: 'Amount(RMB)',  renderCell: ({ row, value }) => jumboco?.curr?.cd + '' + (value || (jumboco?.curr?.Rate * Number(((row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC)) / 100) * row.CARATS)))?.toFixed(2)) },
      // { field: 'MDISC2', headerName: 'Amount(RMB)',renderCell: (row) => jumboco?.curr?.cd +''+ (jumboco?.curr?.Rate *  Number(((row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC || row.ASK_DISC)) / 100) * row.CARATS)).toFixed(2)).toFixed(2) },

      // { field: 'ASK_DISC', headerName: 'ASK($)', renderCell: ({ row }) => (`${(row.RAP_PRICE - (row.RAP_PRICE * (row.ASK_DISC)) / 100).toFixed(2)}/${row.ASK_DISC}`),cellClassName: classes.ASkCell },
      // { field: 'GREEN_DISC', headerName: 'GREEN($)', renderCell: ({ row }) => (`${(row.RAP_PRICE - (row.RAP_PRICE * (row.GREEN_DISC)) / 100).toFixed(2)}/${row.GREEN_DISC}`),cellClassName: classes.GreenCell },
      // { field: 'RED_DISC', headerName: 'RED($)', renderCell: ({ row }) => (`${(row.RAP_PRICE - (row.RAP_PRICE * (row.RED_DISC)) / 100).toFixed(2)}/${row.RED_DISC}`) ,cellClassName: classes.RedCell}
    ];
    // useEffect(()=>{
    //   console.log(SelectedStone);
    // },[SelectedStone])

    const Item = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    }));
    useEffect(() => {
      if (SelectedStone && Stoneresultdata) {
        let ndata = SelectedStone?.flatMap((stone) =>
          Stoneresultdata?.filter((s) => s.STONE === stone)
        );
        // console.log(ndata);
        let tempCal = { pcs: 0, cts: 0, rap: 0, disc: 0 }
        ndata?.forEach(sdata => {
          tempCal = {
            pcs: tempCal.pcs + 1,
            cts: tempCal.cts + sdata.CARATS,
            rap: Number(tempCal.rap) + Number(sdata.RAP_PRICE),
            disc: Number(tempCal.disc) + Number(sdata.MDISC)
          }
        });
        tempCal = {
          pcs: tempCal.pcs,
          cts: tempCal.cts,
          rap: Number(tempCal.rap) / Number(tempCal.pcs),
          disc: Number(tempCal.disc) / Number(tempCal.pcs),
        }
        tempCal = {
          ...tempCal,
          price: Number(tempCal.rap) - (tempCal.rap * tempCal.disc / 100)
        }
        // console.log(tempCal);
        tempCal.pcs != 0 && setSelectedStoneDetails({ ...tempCal, amt: tempCal.price * tempCal.cts })
      }

    }, [SelectedStone, Stoneresultdata]);


    const handlediscChang = async (e, stone, type) => {
      let tmpStoneData = stone;
      let targetData = e.target?.id.split('-');
      // console.log(targetData);
      // console.log(e.target.id);
      if (type == 0) {
        let disc = e.target.value
        tmpStoneData = { ...tmpStoneData, MDISC: disc }
      } else if (type == 1) {
        tmpStoneData = { ...tmpStoneData, MDISC: (100 - (e.target.value * 100) / stone.RAP_PRICE) }
      } else if (type == 2) {
        let tmpAMT = e.target.value / stone.CARATS
        tmpStoneData = { ...tmpStoneData, MDISC: (100 - (tmpAMT * 100) / stone.RAP_PRICE) }
      }
      let ManageStoneDisc = Stoneresultdata?.filter((sd) => sd.STONE !== stone.STONE);
      let tmpprice = (stone.RAP_PRICE - (stone.RAP_PRICE * (tmpStoneData.MDISC)) / 100)
      let FinalObj = { ...tmpStoneData, mPrice: tmpprice, mamt: (tmpprice * stone.CARATS) }
      ManageStoneDisc.push(FinalObj);
      // console.log('type',type != 1 ,typeof(type));
      // console.log(FinalObj.mPrice?.toFixed(2));
      // Sort the array by the STONE property in ascending order
      ManageStoneDisc.sort((a, b) => (a.STONE > b.STONE ? 1 : -1));
      if (type !== 0) { document.getElementById(`${targetData[0]}-0-${targetData[2]}`).value = FinalObj?.MDISC?.toFixed(2) };
      if (type !== 1) { document.getElementById(`${targetData[0]}-1-${targetData[2]}`).value = FinalObj.mPrice?.toFixed(2) };
      if (type !== 2) { document.getElementById(`${targetData[0]}-2-${targetData[2]}`).value = FinalObj.mamt?.toFixed(2) };
      // Set the sorted array to the state (assuming you're using React useState)
      setStoneresultdata(ManageStoneDisc);

    }
    const discvalHandler = async () => {
      let updatedData = basketData.map(data => {
        if (SelectedStone.includes(data.STONE)) {
          return {
            ...data,
            MDISC: Number(discVal.Disc)
          };
        }
        return data; // Return unchanged items
      });
      setStoneresultdata(updatedData);

    }
    const handleCellEditCommit = (params) => {
      // const updatedRows = rows.map((row) =>
      //     row.id === params.id ? { ...row, [params.field]: params.value } : row
      // );
      // setRows(updatedRows);
      console.log(params); // Retrieve the updated value here
    };
    // return(

    // )
    const [rows, setRows] = useState(Stoneresultdata || []);

    const handleEditCellChange = (params) => {
      console.log(params);
      return
      // Access the updated row and change the values of all fields
      const updatedRows = rows.map((row) => {
        if (row.id === params.id) {
          return { ...row, [params.field]: params.props.value };
        }
        return row;
      });
      setRows(updatedRows);
    };
    const handleStoneSelect = (stone) => {
      // console.log(SelectedStone.indexOf(stone));
      // if (SelectedStone.indexOf(stone) === -1) {
      // If the stone is not in SelectedStone, add it
      setSelectedStone(stone);
      // } else {
      //   // If the stone exists in SelectedStone, remove it
      //   const updatedStones = SelectedStone.filter((s) => s !== stone);
      //   setSelectedStone(updatedStones);
      // }
    };
    return (<>
      {Array.isArray(Stoneresultdata) && <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
        overflow={'auto'}
        sx={{ mb: 1 ,textWrap: 'nowrap',py:2}}
      >
        <Item>Pcs = {selectedStoneDetails.pcs || 0}</Item>
        <Item>CTS = {selectedStoneDetails.cts?.toFixed(2) || 0.00}</Item>
        <Item>Rap = {selectedStoneDetails.rap.toFixed(2) || 0}</Item>
        <Item>Disc% = {selectedStoneDetails.disc?.toFixed(2) || 0}</Item>
        <Item>Price = {selectedStoneDetails.price?.toFixed(2) || 0}</Item>
        <Item>Amt ($) = {selectedStoneDetails.amt?.toFixed(2) || 0}</Item>
        <Item>Amt (RMB) = {jumboco?.curr?.cd + '' + ((jumboco?.curr?.Rate * selectedStoneDetails.amt) || 0)?.toFixed(2) || 0}</Item>
        <div style={{ marginLeft: 'auto' }}><Stack direction="row" spacing={2}>

          {/* <Select
                labelId="Select-disc"
                id="Select-disc-se"
                // value={selectedValue}
                name='discType'
                variant="outlined"
                margin="dense"
                fullWidth
                size='small'
              value={discVal.discType}

                onChange={e=>setDiscVal({...discVal,discType:e.target.value})}
              >
                <MenuItem value="ASK_DISC">Ask Disc</MenuItem>
                <MenuItem value="GREEN_DISC">Greed Disc</MenuItem>
                <MenuItem value="RED_DISC">Red Disc</MenuItem>
              </Select> */}
          {/* <TextField
            fullWidth
            size='small'
            name="Disc"
            label="Disc %"
            value={discVal.Disc}
            onChange={e => setDiscVal({ ...discVal, Disc: e.target.value })}
            type="number"
          /><Button variant='outlined' onClick={discvalHandler} disabled={discVal == null} color='primary'>DISC</Button> */}
          </Stack></div>
      </Stack>}
      {/* <Button onClick={getFieldValue(params.id, 'MDISC')}>click</Button> */}
      <TableContainer component={Paper}>
        <Paper>
          <DataGrid
            rows={rows || []}
            columns={columns}
            apiRef={gridRef}
            onRowEditStop={(params) => getFieldValue(params)}

            // onEditRowsModelChange={handleEditCellChange}
            // onEditCellChange={handleEditCellChange}
            autoHeight
            rowSelectionModel={SelectedStone}
            onRowSelectionModelChange={handleStoneSelect}
            onCellEditCommit={handleCellEditCommit}
            // onCellEditStop={handleCellEditCommit}
            // onRowEditCommit={handleCellEditCommit}

            isCellEditable={(params) => params.row.STATUS == 'A'}
            isRowSelectable={(params) => params.row.STATUS == 'A'}
            density='compact'
            editMode='row'
            getRowId={(row) => row.STONE}
            checkboxSelection={(params) => params.row.STATUS == 'A'}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 50,
                },
              },
            }}
            pageSizeOptions={[50]}

            // checkboxSelection
            disableRowSelectionOnClick
          /></Paper>
        {/* {Stoneresultdata == null ? <TableSkeleton cols={15} /> : Stoneresultdata.length > 0 ? <Table sx={{ minWidth: 650 }} size='small' aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell><Checkbox onClick={(e) => {
              if (e.target.checked) {
                let StoneDataFilter = Stoneresultdata?.filter((row, index) => row.STATUS == 'A')
                let stondata = StoneDataFilter?.map((row, index) => row.STONE)
                console.log(stondata);
                stondata ? setSelectedStone(stondata) : setSelectedStone([])
              } else {
                setSelectedStone([])
              }
            }} /></TableCell>
            <TableCell align="center">Party</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center">StoneId</TableCell>
            <TableCell align="center">Lab</TableCell>
            <TableCell align="center">ReportNO</TableCell>
            <TableCell align="center">Shape</TableCell>
            <TableCell align="center">Carats</TableCell>
            <TableCell align="center">Color</TableCell>
            <TableCell align="center">Clarity</TableCell>
            <TableCell align="center">Discount(%)</TableCell>
            <TableCell align="center">Price($)</TableCell>
            <TableCell align="center">Amount($)</TableCell>
            <TableCell align="center">Amount(RMB)</TableCell>
            <TableCell align="center">ASK AMT($)/<sub>DISC(%)</sub></TableCell>
            <TableCell align="center">GREEN AMT($)/<sub>DISC(%)</sub></TableCell>
            <TableCell align="center">RED AMT($)/<sub>DISC(%)</sub></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Stoneresultdata?.map((row, index) => row.STATUS == 'A' &&(
            <TableRow
              key={row.STONE}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row"><Checkbox disabled={row.STATUS != 'A'} checked={SelectedStone.includes(row.STONE)} onClick={() => handleStoneSelect(row)} /></TableCell>
              <TableCell align="right">-</TableCell>
              <TableCell align="right">{row.STATUS}</TableCell>
              <TableCell align="right">{row.STONE}</TableCell>
              <TableCell align="right">{row.LAB}</TableCell>
              <TableCell align="right">{row.REPORTNO}</TableCell>
              <TableCell align="right">{row.SHAPE}</TableCell>
              <TableCell align="right">{row.CARATS}</TableCell>
              <TableCell align="right">{row.COLOR}</TableCell>
              <TableCell align="right">{row.CLARITY}</TableCell>
              <TableCell align="right">
                <TextField size='small' disabled={row.STATUS != 'A'} type='number' id={`input-0-${index}`} min={0} max={100} sx={{ minWidth: 150 }} onBlur={(e) => handlediscChang(e, row, 0)} defaultValue={Number(row.MDISC || row.ASK_DISC).toFixed(2)} />
              </TableCell>
              <TableCell align="right">
                <TextField size='small' disabled={row.STATUS != 'A'}  type='number' id={`input-1-${index}`} min={0} sx={{ minWidth: 150 }} onBlur={(e) => handlediscChang(e, row, 1)} defaultValue={Number(row.mPrice || (row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC || row.ASK_DISC)) / 100)).toFixed(2)} />
              </TableCell>
              <TableCell align="right">
                <TextField size='small' disabled={row.STATUS != 'A'}  type='number' id={`input-2-${index}`} min={0} sx={{ minWidth: 150 }} onBlur={(e) => handlediscChang(e, row, 2)} defaultValue={Number(row.mamt || ((row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC || row.ASK_DISC)) / 100) * row.CARATS)).toFixed(2)} />
              </TableCell>
              <TableCell>
                  {jumboco?.curr?.cd +''+ (jumboco?.curr?.Rate *Number(row.mamt || ((row.RAP_PRICE - (row.RAP_PRICE * (row.MDISC || row.ASK_DISC)) / 100) * row.CARATS))).toFixed(2)}
              </TableCell>
               <TableCell align="right">{((row.RAP_PRICE - (row.RAP_PRICE * row.ASK_DISC / 100)) * row.CARATS).toFixed(2)}/<sub>{row.ASK_DISC}</sub></TableCell>
              <TableCell align="right">{((row.RAP_PRICE - (row.RAP_PRICE * row.GREEN_DISC / 100)) * row.CARATS).toFixed(2)}/<sub>{row.GREEN_DISC}</sub></TableCell>
              <TableCell align="right">{((row.RAP_PRICE - (row.RAP_PRICE * row.RED_DISC / 100)) * row.CARATS).toFixed(2)}/<sub>{row.RED_DISC}</sub></TableCell>
            </TableRow>
          ))}
        </TableBody>

      </Table> : <NoDataPlaceholder />} */}
      </TableContainer></>
    )
  };
  const StoneTableWithBasket = ({ stoneResult, SelectedStone, SelectedStoneBasketData, setSelectedStoneBasketData, Stoneresultdata, setStoneresultdata, setSelectedStone }) => {
    const columns = [
      { field: 'FL_MAIN_LOT', flex: 1, headerName: 'Lot NO.' },
      { field: 'FL_SUB_LOT', flex: 1, headerName: 'Sub Lot' },
      { field: 'FL_SHAPE', flex: 1, headerName: 'Shape' },
      { field: 'FL_COLOR', flex: 1, headerName: 'Color' },
      { field: 'FL_CLARITY', flex: 1, headerName: 'Calrity' },
      { field: 'FL_ASK_AMT', flex: 1, headerName: 'Rate', type: 'number' },
      { field: 'FL_CARATS', flex: 1, headerName: 'Available Carats', type: 'number' },
    ]
    const handleCellEdit = async (params) => {
      // setTimeout(async () => {
      //   let cellval = await gridRef.current.getCellValue(params.id, params.field)
      //   // console.log(cellval);        
      //   // Update the data source with the new value
      //   // alert('commit')
      //   const updatedRows = Stoneresultdata.map(row => {
      //     if (row.FL_SUB_LOT === params.id) {
      //       if (params.field === 'FL_SELL_CARATS') {
      //         return { ...row, [params.field]: cellval <= row.FL_CARATS ? cellval : row.FL_CARATS };
      //       } else {
      //         return { ...row, [params.field]: cellval };
      //       }
      //     }
      //     return row;
      //   });
      //   setStoneresultdata(updatedRows);
      // }, 100);
    };
    // const gridRef = useRef(null);
    return (<Paper>

      <DataGrid
        rows={Stoneresultdata || []}
        columns={columns}
        autoHeight
        // editMode='row'
        // apiRef={gridRef}
        id={'bulk_basket_table'}
        rowSelectionModel={SelectedStone}
        // onCellEditStop={handleCellEdit}
        onRowSelectionModelChange={(e) => setSelectedStone(e)}
        density='compact'
        // isRowSelectable={(params) => Boolean(params.row.FL_SELL_CARATS)}
        // checkboxSelection={(params) => Boolean(params.row.FL_SELL_CARATS)}
        getRowId={(row) => row.FL_SUB_LOT}
        // disableColumnSelector
        checkboxSelection
        disableRowSelectionOnClick
      />
    </Paper>
    )
  }
  return (
    <div>

      <Grid container >
        <Grid item lg={7} xs={10}>
          {/* <Typography variant='h1' sx={{ mb: 3 }}>My Baket</Typography> */}
          <Stack direction={'row'} spacing={2} justifyContent="start" alignItems="center">

            {isMobile? <><LoadingButton variant={inventoryType == 'single' ? "contained" : 'outlined'} onClick={() => { setBasketData(null); setInventoryType('single') }} sx={{ display: 'flex', margin: '0 0px 22px 0' }} color="primary"><DiamondIcon /></LoadingButton>
            </>:
             <><LoadingButton variant={inventoryType == 'single' ? "contained" : 'outlined'} onClick={() => { setBasketData(null); setInventoryType('single') }} sx={{ display: 'flex', margin: '0 0px 22px 0' }} startIcon={<DiamondIcon />} color="primary">Polish Single</LoadingButton>
             </>}
            {/* {isMobile? <><LoadingButton variant={inventoryType == 'single' ? "contained" : 'outlined'} onClick={() => { setBasketData(null); setInventoryType('single') }} sx={{ display: 'flex', margin: '0 0px 22px 0' }} color="primary"><DiamondIcon /></LoadingButton>
            <LoadingButton variant={inventoryType != 'single' ? "contained" : 'outlined'} onClick={() => { setBasketData(null); setInventoryType('bulk') }} sx={{ display: 'flex', margin: '0 0px 22px 0' }} color="primary"><AutoAwesomeMotionOutlinedIcon /></LoadingButton></>:
             <><LoadingButton variant={inventoryType == 'single' ? "contained" : 'outlined'} onClick={() => { setBasketData(null); setInventoryType('single') }} sx={{ display: 'flex', margin: '0 0px 22px 0' }} startIcon={<DiamondIcon />} color="primary">Polish Single</LoadingButton>
             <LoadingButton variant={inventoryType != 'single' ? "contained" : 'outlined'} onClick={() => { setBasketData(null); setInventoryType('bulk') }} sx={{ display: 'flex', margin: '0 0px 22px 0' }} startIcon={<AutoAwesomeMotionOutlinedIcon />} color="primary">Polish Parcel</LoadingButton></>} */}
            
          </Stack>
        </Grid>
        <Grid item lg={5} xs={2}>
          <Grid container sx={{ gap: '14px', justifyContent: 'end', alignItems: 'baseline' }}>
            {/* <ExcelGenerate data={SelectedStoneBasketData} text={'Client Excel'} sx={{ display: 'flex', margin: '0 0px 22px 0' }} /> */}
            {/* <BasketExcelGenerateAdmin data={SelectedStoneBasketData} text={'Admin Excel'}  sx={{ display: 'flex', margin: '0 0px 22px 0' }}/> */}
            {/* <LoadingButton variant="contained" disabled={!SelectedStone?.length > 0} sx={{ display: 'flex', margin: '0 0px 22px 0' }} onClick={CreateeXcelExport} startIcon={<ExitToAppRoundedIcon />} color="primary">Export To Excel</LoadingButton> */}
            {/* <LoadingButton variant="contained" onClick={() => setOpetMemoDialoge(true)} disabled={!SelectedStone?.length > 0} sx={{ display: 'flex', margin: '0 0px 22px 0' }} startIcon={<AutoAwesomeMotionOutlinedIcon />} color="primary">Memo</LoadingButton>
            <LoadingButton variant="contained" onClick={() => setOpetSoldDialoge(true)} disabled={!SelectedStone?.length > 0} sx={{ display: 'flex', margin: '0 0px 22px 0' }} startIcon={<DataThresholdingOutlinedIcon />} color="primary">Sold</LoadingButton> */}
            <ExcelGenerate  text={'Excel'} data={basketData} />
            {isMobile? <Tooltip title="Remove Basket"  color="primary"><Fab size='small'  variant="contained" loading={BLOADER} disabled={!SelectedStone?.length > 0} onClick={RemovetoBasketHandler} sx={{ display: 'flex', margin: '0 0px 22px 0' }} ><RemoveShoppingCartOutlinedIcon /></Fab></Tooltip>:<LoadingButton variant="contained" loading={BLOADER} disabled={!SelectedStone?.length > 0} onClick={RemovetoBasketHandler} sx={{ display: 'flex', margin: '0 0px 22px 0' }} startIcon={<RemoveShoppingCartOutlinedIcon />} color="primary">Remove</LoadingButton>}
          </Grid>
        </Grid>
      </Grid>
      {(inventoryType == 'single' ?
        <StoneTableViewWIthBasket SelectedStoneBasketData={SelectedStoneBasketData} setSelectedStoneBasketData={setSelectedStoneBasketData} Stoneresultdata={basketData} SelectedStone={SelectedStone} setStoneresultdata={setBasketData} setSelectedStone={setSelectedStone} />
        : <StoneTableWithBasket SelectedStoneBasketData={SelectedStoneBasketData} setSelectedStoneBasketData={setSelectedStoneBasketData} Stoneresultdata={basketData} SelectedStone={SelectedStone} setStoneresultdata={setBasketData} setSelectedStone={setSelectedStone} />)
      }
      {/* {SelectedStone?.length > 0 && <> <ShippingFormMemoDialog open={opetMemoDialoge} userSelectedParty={userSelectedParty} basketData={basketData} SelectedStone={SelectedStone} handleClose={() => { setOpetMemoDialoge(!opetMemoDialoge); fetchBasketdata() }} />
        {inventoryType == 'single' ? <ShippingFormSoldDialog open={opetSoldDialoge} userSelectedParty={userSelectedParty} SelectedStone={SelectedStone} handleClose={() => setOpetSoldDialoge(!opetSoldDialoge)} /> : <BulkShippingFormSoldDialog open={opetSoldDialoge} userSelectedParty={userSelectedParty} SelectedStone={SelectedStone} handleClose={() => setOpetSoldDialoge(!opetSoldDialoge)} />}</>} */}
    </div>
  );
}
UserBasket.Modulename = 'UserBasket'





